import React, { Component, ReactNode } from "react";
import { observer } from "mobx-react";
import LayoutFieldsConfigController from "../../components/template-configuration/layout-level-fields.controller";

interface IProp {
    changeHandler :Function,
    selectedLookupFilter :any[],
    selectedTemplateName :string,
    addLayoutField : Function,
    deleteLookupFilter : Function,
    updateLookupFilter: Function
}

class TriggeringField extends Component<IProp, any>{
    private readonly layoutFieldsConfigCtrl: LayoutFieldsConfigController;
    constructor(props :any){
        super(props);
        this.state = {
            layoutFieldsArray: []
        }
        this.layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
    }

    private fetchLookupFieldData = () => {
        const layoutFields = this.layoutFieldsConfigCtrl.getLayoutFields(this.props.selectedTemplateName);
        this.setState({
            layoutFieldsArray: layoutFields
        });
    }

    componentDidMount(){
        if(this.state.layoutFieldsArray.length === 0){
            this.fetchLookupFieldData();
        }
    }

    render() :ReactNode{
        const {changeHandler, selectedLookupFilter} = this.props;
        return(
            selectedLookupFilter.map((selectedLookupField: string, index: number) => {
                return (
                    <div key={index} className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                        <div className="slds-col col-sm slds-m-bottom_small">{index + 1}</div>
                        <div className="slds-col slds-size_7-of-12">
                            <div className="slds-form-element">
                                <div className="slds-form-element__control">
                                    <div className="slds-select_container">
                                        <select
                                            name="objLayoutFieldsArray" 
                                            role="triggerSelect"
                                            className="slds-select" 
                                            id="select-01"
                                            value={selectedLookupField===""?this.props.updateLookupFilter():selectedLookupField}
                                            onChange={(e) => changeHandler(e, index)}
                                            >
                                            <option value="">Select field</option>
                                            {
                                                this.state.layoutFieldsArray && this.state.layoutFieldsArray.map((field :any) => {
                                                    return(
                                                        <option key={field.fieldFullName} value={field.fieldFullName}>{`${field.fieldLabel} - ${field.fieldFullName}`}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="slds-col slds-size_5-of-12">
                            <div className="slds-grid slds-m-bottom_xx-small">
                                <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" role="add-select" onClick={() => {
                                    this.props.addLayoutField();
                                }}>
                                    <i className="cq-icon-add cq-1x"></i>
                                </button>
                                {index !== 0 &&
                                    <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-top_none" role="delete-select" onClick={() => {
                                        this.props.deleteLookupFilter(index);
                                    }}>
                                        <i className="cq-icon-delete cq-1x"></i>
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                );
            })
        );
    }
}

export const ApplyTriggeringField = observer(TriggeringField);